import { useState } from 'react';
import { GridColumnVisibilityModel } from '@mui/x-data-grid';

interface UseVisibleColumnsProps {
    columnNames: string[];
    disableColumnMenu?: boolean;
    defaultColumns?: string[];
    storagePrefix: string;
}

export function useVisibleColumns({
    columnNames,
    disableColumnMenu = false,
    defaultColumns = [],
    storagePrefix,
}: UseVisibleColumnsProps) {
    const [visibleColumns, setVisibleColumns] = useState<GridColumnVisibilityModel | undefined>(() => {
        if (disableColumnMenu) return;

        return Object.fromEntries(
            columnNames.map((key) => {
                const stored = localStorage.getItem(`${storagePrefix}-${key}`);

                if (stored !== null) return [key, stored !== 'false'];
                if (defaultColumns.length > 0) return [key, defaultColumns.includes(key)];
                return [key, true];
            }),
        );
    });

    const handleColumnVisibilityChange = (model: GridColumnVisibilityModel) => {
        if (disableColumnMenu) return;
        setVisibleColumns(model);
        columnNames.forEach((key) => {
            localStorage.setItem(`${storagePrefix}-${key}`, String(model[key] ?? true));
        });
    };

    return {
        visibleColumns,
        onColumnVisibilityModelChange: handleColumnVisibilityChange,
    };
}
